import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import Button from '@salesforce/design-system-react/components/button';
import { BrowserRouter as Router, RouteComponentProps, withRouter } from 'react-router-dom';

interface EventId {
  eventExternalId: string;
  eventId: string;
  visualIndicator?: string;
  status?: string;
}

// interface for props that the data table cell is getting default from data table.
export interface Props extends RouteComponentProps {
  children?: FC;
  item?: EventId;
  transferType: string;
}

const TransferIdCell: FC<Props> = ({
  item = {
    eventExternalId: null,
    eventId: null,
    status: '',
    visualIndicator: '',
  },
  history,
}) => {
  const { eventId, eventExternalId } = item;
  const goToTransferDetails = (): void => {
    history.push('/surgicalDetails', {
      eventType: '',
      externalId: eventExternalId,
      id: eventId,
    });
  };

  return (
    <Router>
      <DataTableCell title={eventId || ''}>
        <Button label={eventId || '--'} variant="base" onClick={goToTransferDetails} />
      </DataTableCell>
    </Router>
  );
};

export default withRouter(TransferIdCell);
